import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@/components/atoms';
import { DialogueProps } from './Dialogue.props';
import { DIALOGUE_SIZE_MAP } from './Dialogue.theme';

export const Dialogue = ({
  children,
  onClose,
  title,
  content,
  actions,
  showClose = false,
  size = 'md',
  ...props
}: DialogueProps) => {
  const sizeConfig = DIALOGUE_SIZE_MAP[size ?? 'md'] || DIALOGUE_SIZE_MAP.md;

  const dialogProps = {
    ...props,
    PaperProps: {
      ...(props as any)?.PaperProps,
      sx: {
        ...((props as any)?.PaperProps?.sx || {}),
        maxWidth: sizeConfig.maxWidth,
        maxHeight: sizeConfig.maxHeight,
        width: sizeConfig.width ?? '100%',
        height: sizeConfig.height ?? 'auto',
      },
    },
  } as any;

  return (
    <MuiDialog onClose={onClose} {...dialogProps}>
      {/* Header group: Close button and Title together */}
      {(showClose || title) && (
        <Box>
          {/* First row: Close button in extreme right */}
          {showClose && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <IconButton
                size="s"
                variant="standard"
                onClick={(e) => {
                  if (onClose) {
                    onClose(e, 'backdropClick');
                  }
                }}
                sx={{
                  color: 'M3.sys.light.on-surface-variant',
                  padding: 0,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          )}

          {/* Second row: Title */}
          {title && <DialogTitle>{title}</DialogTitle>}
        </Box>
      )}

      {/* Content row: content prop takes precedence over children */}
      {content ? (
        <DialogContent>{content}</DialogContent>
      ) : (
        children && <DialogContent>{children}</DialogContent>
      )}

      {/* Last row: Actions */}
      {actions && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialogue;
